import { combineReducers } from 'redux';

import { IListing } from '@travelnest/typewriter';

import { Actions, ActionTypes } from './actions';

const receiveListingsByProperty = (current: IListing[], next: IListing[]) => {
	const newIds = next.map((l) => l.channel_id);
	return current.filter((l) => !newIds.includes(l.channel_id)).concat(next);
};

export const byPropertyId = (state = {} as { [key: string]: IListing[] }, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.LISTINGS_BY_PROPERTY_ID_RECEIVE:
			const current = state[action.payload.id] || [];
			const next = action.payload.listings;
			return { ...state, [action.payload.id]: receiveListingsByProperty(current, next) };
		case ActionTypes.LISTINGS_BY_PROPERTY_ID_FAILURE:
			return { ...state, [action.payload.id]: [] };
		default:
			return state;
	}
};

export const byListingId = (state = {} as { [key: string]: IListing }, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.LISTING_BY_LISTING_ID_RECEIVE:
		case ActionTypes.LISTING_UPDATE_RECEIVE:
			return { ...state, [action.payload.id]: action.payload };
		default:
			return state;
	}
};

export interface IListingsState {
	byPropertyId: ReturnType<typeof byPropertyId>;
	byListingId: ReturnType<typeof byListingId>;
}

export default combineReducers<IListingsState>({
	byPropertyId,
	byListingId
});
